import { render, staticRenderFns } from "./CrmSalonPipeline.vue?vue&type=template&id=94979e00&"
import script from "./CrmSalonPipeline.vue?vue&type=script&lang=js&"
export * from "./CrmSalonPipeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports